import { useSettings } from '@/data/Settings';
import { useCallback, useMemo } from 'react';

import { BTPayload } from './types';
import { getBttUT, getVirtualPageName, retrieveStoreConfMapping } from './utils';

export const useTrackBlueTrianglePageTurns = () => {
	const { settings } = useSettings();
	const { userData } = settings;

	const mappings = useMemo(() => retrieveStoreConfMapping(userData ?? {}), [userData]);
	const enabled = userData?.BT_ACTIVE_FLAG === 'true';
	const txnName = userData?.BT_ENVIRONMENT;

	const buildPayload = useCallback(
		(pathname: string): BTPayload | null => {
			if (!enabled || !txnName || mappings.length === 0) return null;
			return {
				pageName: getVirtualPageName({ pathname, mappings }),
				txnName,
			};
		},
		[enabled, txnName, mappings]
	);

	const trackStart = useCallback(
		(pathname: string): BTPayload | null => {
			const payload = buildPayload(pathname);
			if (!payload) return null;
			const bttUT = getBttUT();
			if (!bttUT) return null;
			try {
				bttUT.start(payload);
				return payload;
			} catch (error) {
				console.error('[BT] bttUT.start():', error);
				return null;
			}
		},
		[buildPayload]
	);

	const trackEnd = useCallback((payload: BTPayload): void => {
		const bttUT = getBttUT();
		if (!bttUT) return;
		try {
			bttUT.end(payload);
		} catch (error) {
			console.error('[BT] bttUT.end():', error);
		}
	}, []);

	return { trackStart, trackEnd };
};
